import {getAnalytics, getHeader, addMainHeader, getAuthors, getAuthorsPage} from "../../api/app";
import ContentPage from "../../components/contentPage/ContentPage";
import PageDescription from "../../components/baseComponents/head/pageDescription/PageDescription";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useRouter} from "next/router";
import {createMetaData} from "../../utils/data/createMetaData";
import classNames from "classnames";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import AuthorInfo from "../../components/authorInfo/AuthorInfo";
import {createNewsDate} from "../../utils/data/createData";
import panel, {addData, addAuthorData, usePanel} from "../../redux/reducer/panel";
import {useDispatch} from "react-redux";
import Head from "next/head";
import {NEXT_PUBLIC_BASE_URL} from "../../constants/copyright";

export default function AuthorPage({authorsData, slug}) {
  const router = useRouter();
  const {query: {}} = router;
  const [page, setPage] = useState(1);
  const [activeFilter, setActiveFilter] = useState(false)
  const dispatch = useDispatch()
  const {filter, authorData} = usePanel()

  // const {title,description} = authorsInfo.data
  console.log(authorsData, 'AUTHOR-INFO')


  const {likes, views_count, commentsCount, recommendations, author,description} = authorsData.info

  const authorContent = useMemo(() => {
    return authorData ? authorData : authorsData.content
  }, [authorsData.content, authorData])

  const recommendationList = createNewsDate(recommendations)

  const authorTags = useMemo(() => [
    // {type: "date", value: created_at},
    // {type: "time", value: content.time},
    {type: "views", value: views_count},
    {type: "likes", value: likes},
    {type: "comments", value: commentsCount}
  ], [authorsData])

  const switchTab = useCallback((filter) => {
    setActiveFilter(filter);
    setPage(1)
  }, [page, activeFilter])

  useEffect(() => {
    dispatch(addAuthorData(authorsData.content))
  }, [authorsData.content])

  useEffect(() => {
    dispatch(panel.thunks.getAuthorFilter({slug, page, heading: activeFilter}));
  }, [activeFilter, page]);

  const canonicalUrl = `${NEXT_PUBLIC_BASE_URL}${router.asPath.split('?')[0]}`; // Формирование канонического URL

  if (router.isFallback) {
    return <div>Loading...</div>
  }

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <div className={'container'}>
        <PageDescription {...createMetaData('Автор', 'Инофрмация о авторе',author.photo,null,null,canonicalUrl,'author')}/>
        <SwitchTransition>
          <CSSTransition key={`filter`} timeout={500} classNames={"content-page"}>
            <AuthorInfo
              author={author}
              description={description}
              tabs={authorsData.info.headings}
              info={authorContent}
              tags={authorTags}
              recommendation={recommendationList}
              switchTab={switchTab}
              setPage={setPage}
            />
          </CSSTransition>
        </SwitchTransition>
      </div>
    </>
  )
}


export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  if (!params?.slug) {
    return { notFound: true }
  }

  const slug = params.slug

  try {
    console.log(
      new Date().toLocaleString(),
      '[author] getStaticProps',
      slug
    )

    const [analytic, header, authorsData] = await Promise.all([
      getAnalytics(),
      getHeader(),
      getAuthorsPage({ slug }),
    ])

    if (!authorsData) {
      return { notFound: true }
    }

    return {
      props: {
        analytic,
        data: {
          header,
          authorsData,
        },
        authorsData,
        slug,
      },
      revalidate: 10,
    }
  } catch (error) {
    const status = error?.data?.status || error.code || error.statusCode;
    if(status === 404) {
      return { notFound: true };
    } else {
      console.error('[...aId] FETCH ERROR', error);
      throw error;
    }
  }
}



